import React from "react";

export const Pricing = (props) => {
  console.log(props.data);
  return (
    <div id="pricing" className="text-center">
      <div className="container">
        <div className="section-title">
          {/* <img src="img/picsla-maxi.png" className="pricing-img pricing-img-left" alt="" /> */}
          <img src="img/picsla-maxi.png" className="pricing-img pricing-img-right" alt="" />
          <h2> {props.data ? props.data.title : "Loading..."}</h2>
          {/* <p>
          {props.data ? props.data.subtitle : "Loading..."}
          </p> */}
        </div>
        <div className="row list-style pricing-text">
          {" "}

            {props.data && props.data.pricelists
              ? props.data.pricelists.map((pricelist, i) => (
                    <div key={`${pricelist.title}-${i}`}className="col-lg-3 col-sm-6 col-xs-12">
                      <div className="pricing-box">
                        <div className="pricing-title">
                          {pricelist.title}
                        </div>
                        <div className="pricing-list">
                          <ul>
                            {pricelist.fragments.map((feature, key) => (
                              <li key={`${feature}-${key}`}>{feature}</li>
                            ))}
                          </ul>
                        </div>
                        <div className="pricing-price">
                          <div className="btn">
                            {pricelist.price}
                          </div>
                        </div>
                      </div>
                    </div>
                ))
              : "Loading..."}{" "}
          </div>
      </div>
    </div>
  );
};
